import { coreUrls } from '@/api/urls/core';

import { setApiOptions } from '@/utilities/services';

import { RequestResponseType } from '../../../../models';
import { azkivamProPayServiceBodyParams, azkivamProPayServiceResponse, GetProfileResponseType } from './models';

import { api } from '@/api/client';
import { AxiosPromise } from 'axios';

export const getProfileService = () => {
    const options = setApiOptions(coreUrls.getProfile);
    return api({ ...options, method: 'GET' });
};

export const setFCMTokenService = (token: string): AxiosPromise<GetProfileResponseType> => {
    const options = setApiOptions(coreUrls.setFCMToken, { bodyParam: { token } });
    return api({ ...options, method: 'POST' });
};

export const patchProfileIdentityInfoService = ({ bodyParam }: azkivamProPayServiceBodyParams): AxiosPromise<any> => {
    const options = setApiOptions(coreUrls.patchProfileIdentityInfo, { bodyParam });
    return api({ ...options, method: 'PATCH' });
};

export const setAzkivamProPayService = (): AxiosPromise<RequestResponseType<azkivamProPayServiceResponse>> => {
    const options = setApiOptions(coreUrls.setAzkivamProPay);
    return api({ ...options, method: 'POST' });
};
